import { LE } from "@/constants/enums";
import { assignFilesAndDocsByDocType, FileDocPropertyName } from "@modernary/mui/components/document";
import { fillLookupValuesByPropertyNames } from "@modernary/mui/components/lookup";
import type { ReleaseEvent, ReleaseEventConfirmedResponse } from "./releaseEvent";

export default {
  addAuthRequestFields,
  skinnyResponseAdapter,
  responseAdapter,
  getInitialData,
  toFormkit,
  fromFormkit,
};
export const releaseEventDocTypeToFieldMap = new Map<LE.DocumentType, FileDocPropertyName>([
  [LE.DocumentType.SuspectedReleaseNotification, new FileDocPropertyName("suspectedReleaseNotification")],
  [LE.DocumentType.ConfirmedReleaseNotification, new FileDocPropertyName("confirmedReleaseNotification")],
]);

function addAuthRequestFields(entity: ReleaseEvent) {
  entity._authRequestFields = ["id", "facilityId", "statusMurn", "typeMurn"] as (keyof ReleaseEvent)[];
  return entity;
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: ReleaseEvent }) {
  addAuthRequestFields(response.data);
  await fillLookupValuesByPropertyNames(response.data, ["sourceMurn", "typeMurn"]);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: ReleaseEvent }) {
  await skinnyResponseAdapter(response);

  assignFilesAndDocsByDocType(releaseEventDocTypeToFieldMap, response.data, response.data.documents);

  if (response.data.typeMurn == LE.ReleaseEventType.Confirmed && !response.data.confirmedResponse)
    response.data.confirmedResponse = {} as ReleaseEventConfirmedResponse;

  return response.data;
}

function getInitialData() {
  const result = {} as ReleaseEvent;
  return addAuthRequestFields(result);
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: ReleaseEvent) {
  if (data.typeMurn == LE.ReleaseEventType.Confirmed && !data.confirmedResponse)
    data.confirmedResponse = {} as ReleaseEventConfirmedResponse;
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: any) {}
